

exports.__esModule = true;
exports.$FreeReturnShippingOptInModel = exports.$FreeReturnShippingApplicabilityModel = undefined;

var _squid = require('squid');

var $FreeReturnShippingApplicabilityModel = exports.$FreeReturnShippingApplicabilityModel = _squid.$Model.extend('$FreeReturnShippingApplicabilityModel', {
    api: new _squid.$Api({
        uri: '/api/offers/freeReturnShipping/checkApplicability'
    })
});

var $FreeReturnShippingOptInModel = exports.$FreeReturnShippingOptInModel = _squid.$Model.extend('$FreeReturnShippingOptInModel', {
    api: new _squid.$Api({
        uri: '/api/offers/freeReturnShipping/optInUser'
    })
});

_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/frs/index.js
// module id = ./components/xo-models/src/frs/index.js
// module chunks = 1